import { TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { useFilterReset } from "../FilterResetContext";

interface TextFilterProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export default function TextFilter(props: TextFilterProps) {
  const { resetKey } = useFilterReset();
  // const [text, setText] = useState("");

  // clear text if navbar item clicked using context
  useEffect(() => {
    props.onChange(""); // Clear value on navbar reset
  }, [resetKey]);

  // const handleKeyDown = async (
  //   event: React.KeyboardEvent<HTMLInputElement>
  // ) => {
  //   if (event.key === "Enter") {
  //     event.preventDefault();
  //   }
  // };

  return (
    <TextInput
      label={props.label}
      placeholder=""
      value={props.value}
      onChange={(e) => props.onChange(e.currentTarget.value)}
      // onKeyDown={handleKeyDown}
      mb="md"
    />
  );
}
